import script from "./Spreadsheet.vue?vue&type=script&setup=true&lang=js"
export * from "./Spreadsheet.vue?vue&type=script&setup=true&lang=js"

import "./Spreadsheet.vue?vue&type=style&index=0&id=2362a1a4&scoped=true&lang=css"

import exportComponent from "/home/lucas/projects/distrisuper/pc-21/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2362a1a4"]])

export default __exports__